import React from "react";
import { Form, Select, Tooltip, TimePicker } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import {
  type Third,
  THIRD_LABEL,
  THIRD_ORDER,
  buildThirdDisabledTime,
} from "../calendarCreateModal.helpers";

const HORA_TOOLTIP =
  "Mañana: 00:00–10:59 · Medio día: 11:00–14:59 · Tarde/Noche: 15:00–23:59";

export const StartThirdField: React.FC = () => (
  <Form.Item
    name="startThird"
    label="Tercio inicial"
    rules={[{ required: true, message: "Seleccione tercio inicial" }]}
  >
    <Select>
      {THIRD_ORDER.map((t) => (
        <Select.Option key={t} value={t}>
          {THIRD_LABEL[t]}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);

export const EndThirdField: React.FC = () => (
  <Form.Item
    name="endThird"
    label="Tercio final"
    rules={[{ required: true, message: "Seleccione tercio final" }]}
  >
    <Select>
      {THIRD_ORDER.map((t) => (
        <Select.Option key={t} value={t}>
          {THIRD_LABEL[t]}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);

export const StartTimeField: React.FC<{ third: Third }> = ({ third }) => (
  <Form.Item
    name="startTime"
    label={
      <span>
        Hora inicial{" "}
        <Tooltip title={HORA_TOOLTIP}>
          <InfoCircleOutlined style={{ opacity: 0.7 }} />
        </Tooltip>
      </span>
    }
    rules={[{ required: true, message: "Seleccione hora inicial" }]}
  >
    <TimePicker
      format="HH:mm"
      minuteStep={5}
      style={{ width: "100%" }}
      disabledTime={buildThirdDisabledTime(third)}
    />
  </Form.Item>
);

export const EndTimeField: React.FC<{ third: Third }> = ({ third }) => (
  <Form.Item
    name="endTime"
    label={
      <span>
        Hora final{" "}
        <Tooltip title={HORA_TOOLTIP}>
          <InfoCircleOutlined style={{ opacity: 0.7 }} />
        </Tooltip>
      </span>
    }
    rules={[{ required: true, message: "Seleccione hora final" }]}
  >
    <TimePicker
      format="HH:mm"
      minuteStep={5}
      style={{ width: "100%" }}
      disabledTime={buildThirdDisabledTime(third)}
    />
  </Form.Item>
);
